var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivitylog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 0.6,
    width: 27.8,
    height: 27.8,
    rx: 5.44167,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 0.6,
    width: 27.8,
    height: 27.8,
    rx: 5.44167,
    stroke: "#E2E2E2",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2857_4259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 21.5H14.5C14.2348 21.5 13.9804 21.3946 13.7929 21.2071C13.6054 21.0196 13.5 20.7652 13.5 20.5V19H14.5V20.5H20.5V8.5H14.5V10H13.5V8.5C13.5 8.23478 13.6054 7.98043 13.7929 7.79289C13.9804 7.60536 14.2348 7.5 14.5 7.5H20.5C20.7652 7.5 21.0196 7.60536 21.2071 7.79289C21.3946 7.98043 21.5 8.23478 21.5 8.5V20.5C21.5 20.7652 21.3946 21.0196 21.2071 21.2071C21.0196 21.3946 20.7652 21.5 20.5 21.5Z",
    fill: "#2CCAAA",
    stroke: "#1FB395",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.795 16.795L16.585 15H9.5V14H16.585L14.795 12.205L15.5 11.5L18.5 14.5L15.5 17.5L14.795 16.795Z",
    fill: "#2CCAAA",
    stroke: "#1FB395",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2857_4259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitylog);
export default __webpack_public_path__ + "static/media/activitylog.1240c011aacdb58e17b71724b1ce60e9.svg";
export { ForwardRef as ReactComponent };